export default {
	site_name: 'avba',
};
